import type { Decision } from "./types";

export function summarizeDecisions(decisions: Map<string, Decision>): string {
  const values = [...decisions.values()];
  const kept = values.filter((decision) => decision === "KEEP").length;
  const adjusted = values.filter((decision) => decision === "ADJUSTED").length;
  const paused = values.filter((decision) => decision === "PAUSED").length;
  const parts = [
    kept > 0 ? `${kept} kept` : null,
    adjusted > 0 ? `${adjusted} adjusted` : null,
    paused > 0 ? `${paused} paused` : null,
  ].filter((part): part is string => part !== null);

  return parts.length > 0 ? parts.join(" · ") : "Nothing changed.";
}
